import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken } from './auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/v1',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  error => Promise.reject(error)
)

function apiMessage(body, fallback) {
  if (!body) return fallback
  if (body.msg) return body.msg
  const detail = body.detail
  if (typeof detail === 'string' && detail) return detail
  if (Array.isArray(detail) && detail[0]) return detail[0].msg || detail[0].detail || fallback
  return fallback
}

service.interceptors.response.use(
  response => {
    const body = response.data
    if (!body || body.code !== 200) {
      const message = apiMessage(body, '请求失败')
      Message.error(message)
      return Promise.reject(new Error(message))
    }
    return body.data
  },
  error => {
    const status = error.response && error.response.status
    const body = error.response && error.response.data
    const message = apiMessage(body, error.message || '网络异常')
    if (status === 401) {
      store.dispatch('user/logout')
      if (router.currentRoute.path !== '/login') router.replace('/login')
    }
    Message.error(message)
    error.message = message
    return Promise.reject(error)
  }
)

export default service

